import React, {Component} from 'react'
import SampleStartTable from "../SampleStartTable";
import CreateTable from "./CreateTable";
import DocsBaseURL from '../../DocsBaseURL';
import DocsPostRequest from '../../DocsPostRequest';
import DocsPostBodyParameters from "./DocsPostBodyParameters";
import DocsPostBodyReq from "./DocsPostBodyReq";
import DocsPostHeaderParameters from "../../DocsPostHeaderParameters";
import PostHeaderReq from "./PostHeaderReq";
import DocsPostResponseCode from "../../DocsPostResponseCode";

class CreateIndex extends Component {
    render() {
        return (
            <div>
                <div className="docsSection">
                    <p className="docsHeader"><b>Create</b> refers to creating new rows in the file</p>
                    <br/>
                    <div className="row">
                        <div className="col-sm-6">
                            <SampleStartTable/>
                        </div>
                        <div className="col-sm-6">
                            <CreateTable/>
                        </div>
                    </div>
                </div>
                <div className="docsSection">
                    <p className="docsHeader" style={{marginBottom: "0", paddingBottom: "0"}}>Request</p>
                    <hr/>
                    <p className="docsHeader">1. Make a <b>POST</b> Request to the following URL</p>
                    <DocsBaseURL url="data/[fileID]/"/>
                    <i>Example URL</i>
                    <DocsBaseURL url="data/aBcDe123xy0z/" />
                    <DocsPostRequest type="url" />
                    <hr/>
                    <br/>
                    <p className="docsHeader">2. Include a JSON Encoded Body that contains the Row(s)</p>
                    <div className="row">
                        <div className="col-sm-6">
                            <DocsPostBodyParameters/>
                        </div>
                        <div className="col-sm-6">
                            <DocsPostBodyReq/>
                        </div>
                    </div>
                    <hr/>
                    <br/>
                    <p className="docsHeader" style={{color: 'gray'}}>3. Add Keys in the Request Header <i>if private</i></p>
                    <div className="row">
                        <div className="col-sm-6">
                            <DocsPostHeaderParameters/>
                        </div>
                        <div className="col-sm-6">
                            <PostHeaderReq/>
                        </div>
                    </div>
                </div>
                <div className="docsSection">
                    <p className="docsHeader" style={{marginBottom: "0", paddingBottom: "0"}}>Response</p>
                    <hr/>
                    <span>The following response codes can be returned</span>
                    <div style={{fontSize: '115%'}}>
                        <DocsPostResponseCode/>
                    </div>
                </div>
            </div>
        )
    }
}

export default CreateIndex